export default "__VITE_ASSET__B2U051d5__"